export default __webpack_public_path__ + "static/media/login3.ffb32bc3.png";